module.exports = __webpack_public_path__ + "static/media/training1.527d6b91.png";